import store from '@/store'

export const newSystem = {
  id: null,
  customer: '',
  department: '',
  supplier: null,
  toms: '',
  comments: [],
  attachments: [],
  modified_by: '',
  added: '',
  modified: '',
  name: '',
  purpose: '',
  storage_place: '',
  other_responsible: '',
  authentication: '',
  deletion: null,
  backup: '',
  remarks: null
}

export const newVT = {
  id: null,
  customer: '',
  system: null,
  system_id: null,
  affected_person: [],
  data_type: [],
  comments: [],
  attachments: [],
  tasks: [],
  modified_by: null,
  added: '',
  modified: '',
  name: '',
  description: null,
  purpose: '',
  process_type: '',
  data_origin: '',
  person_informed: false,
  person_informed_remarks: null,
  legal_base: '',
  legal_base_remarks: '',
  data_protection: '',
  supplier: null,
  supplier_id: null,
  process_place: '',
  access_rights: '',
  storage_duration: '',
  storage_should: '',
  reason_extended_storage: '',
  delete_method: '',
  delete_process: '',
  delete_department: '',
  storage_legal_base: '',
  legitimate_interest: '',
  affected_interests: '',
  interest_balance: '',
  intern_receipt: '',
  extern_receipt: '',
  data_transfer: false,
  data_transfer_remarks: null,
  profiling: false,
  profiling_remarks: null,
  evaluation: false,
  evaluation_remarks: null,
  document: null,
  storage_place: null,
  stand: null,
  departments: []
}

export const newTodo = {
  id: null,
  object_id: null,
  status: 'Offen',
  priority: 'Prio A',
  steps: [],
  comments: [],
  modified_by: '',
  assigned_to_char: '',
  origin: '',
  sequence: 0,
  description: '',
  on_hold: false,
  start_date: null,
  due_date: null,
  question: null,
  crm_works: null,
  last_escalation: '',
  customer: null,
  assigned_to: '',
  topic: null,
  model: '',
  recurring: false,
}


export const newWork = {
  id: null,
  subject: '',
  customer: null,
  contract: null,
  human_resource: null,
  start_time: null,
  worked_hours: 0.0,
  chargable_hours: 0.0,
  chargable_euro: 0.00,
  short_description: ''
}

export const newAudit = {
    "id": null,
    "customer": "",
    "default_start": "1999-12-01",
    "last_finish": null,
    "modified_by": "",
    "name": "",
    "description": "",
    "audit": true,
    "frequency": 12,
    "duration": 7,
    "question": 3256
}

export const newStep = {
  id: null,
  task: null,
  name: '',
  modified_by: '',
  assigned_to: '',
  status: 'Offen',
}

export const todoOriginText = {
  vt: 'Aktualisiert durch VT',
  question: 'Aktualisiert durch GAP Analyse',
  audit: 'Aktualisiert durch Audit/Review',
}

export const STATUS = [
  {value: 'Offen', label: 'Offen'},
  {value: 'In Bearbeitung', label: 'In Bearbeitung'},
  {value: 'Annulliert', label: 'Annulliert'},
  {value: 'Abgeschlossen', label: 'Abgeschlossen'},
  {value: 'Duplikat', label: 'Duplikat'},
]

export const PRIORITY = [
  {value: 'Prio A', label: 'Prio A'},
  {value: 'Prio B', label: 'Prio B'},
  {value: 'Prio C', label: 'Prio C'},
  {value: 'Prio D', label: 'Prio D'},
]

export const getURL = {
  question: (id) => `todos/v1/get_gap/${id}/`,
  supplier: (id) => `todos/v1/get_supplier/${id}/`,
  system: (id) => `todos/v1/get_system/${id}/`,
  vtverarbeiter: (id) => `todos/v1/get_vtverarbeiter/${id}/`,
  task: (id) => `todos/v1/get_task/${id}/`,
  vt: (id) => `todos/v1/get_vt/${id}/`,
}

export const objectModalName = {
  question: 'related_gap',
  questionSimple: 'related_simple_gap',
  questionSurvey: 'related_gap_survey',
  task: 'add_massnahme',
  system: 'related_system',
  vtverarbeiter: 'related_vtverarbeiter',
  supplier: 'related_supplier',
  vt: 'related_vt',
  incident: 'related_incident',
  sharedResponsibility: 'shared_responsibility',
  auditTemplate: 'audit_template',
  riskAnalysis: 'risk_analysis',
  riskSurvey: 'risk_survey',
  new_system_assessment: 'new_system_assessment',
  system_assessment: 'system_assessment',
}

export const newQuestion = {
  id: null,
  category: '',
  topic: {
  name: '',
    description: '',
    old_intern_number: '',
    new_intern_number: '',
    help_text:  ''
  },
  topic_internal_number: '',
  answers: [],
  last_answer: {},
  question_type: '',
  tasks: [],
  priority: '',
  comments: [],
  attachments: [],
  added: '',
  modified: '',
  name: '',
  old_intern_number: '',
  new_intern_number: '',
  description: '',
  help_text: '',
  statement_yes: '',
  statement_no: '',
  statement_partial: '',
  statement_irrelevant: '',
  content: '',
  customize_statement: '',
  points: 100,
  possible_task: '',
  intern_document_remark: '',
  document_required: null,
  isms_matching: null,
  remarks: '',
  modified_by: '',
  customer: null,
  departments: [],
  display_topics: [],
  intern_document: []
}

export const newAnswer= {
  id: null,
  comments: '',
  statementYes: '',
  statementNo: '',
  statementPartial: '',
  given_by: '',
  document: '',
  stand: '',
  modified_by: ''
}

export const  newSupplier = {
    "id": null,
    "customer": "",
    "data_type": [],
    "systems": [],
    "added": "",
    "modified": "",
    "name": "",
    "address": null,
    "description": "",
    "purpose": "",
    "place": "",
    "responsible_department": "",
    "data_processor": true,
    "legal_base": "",
    "contract": "",
    "responsible": "",
    "checked": false,
    "subcontractor": "",
    "subcontractor_checked": false,
    "document": null,
    "storage_place": null,
    "stand": null,
    "remarks": null,
    "modified_by": null
  }

export const newIncident = {
  "id": null,
  "customer": "",
  "modified_by": null,
  "added": "",
  "modified": "",
  "datetime": null,
  "reporter": "",
  "description": "",
  "consequence": "",
  "inform_lda": true,
  "date_inform_lda": null,
  "inform_affected": true,
  "inform_affected_remarks": "",
  "tasks": [],
  "followups": "",
  "responsible": "",
  "remarks": ""
}

export const newVTVerarbeiter = {
  "id": null,
  "toms": "",
  "added": "",
  "modified": "",
  "name": "",
  "description": "",
  "controller": "",
  "legal_base": "",
  "process_name": "",
  "stand": null,
  "modified_by": null,
  "customer": ""
}

export const newSharedResponsibility = {
  "id": null,
  "customer": "",
  "modified_by": null,
  "added": "",
  "modified": "",
  "processor": "",
  "how": "",
  "legal_base": "",
  "storage_place": "",
  "informer": "",
  "deleter": "",
  "responser": "",
  "remarks": "",
  "data_type": []
}

export const organizedResult = {
  "zutrittskontrolle": {
    "color": "ff0000",
    "points": 4,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Zugangskontrolle": {
    "color": "ff0000",
    "points": 2,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Zugriffskontrolle": {
    "color": "ff0000",
    "points": 3,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": [],
  },
  "Weitergabekontrolle": {
    "color": "ff0000",
    "points": 6,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Pseudonymisierung": {
    "color": "ff0000",
    "points": 0,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Trennungskontrolle": {
    "color": "ff0000",
    "points": 4,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  },
  "Eingabekontrolle": {
    "color": "ff0000",
    "points": 2,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": [],
  },
  "Verfuegbarkeitskontrolle": {
    "color": "ff0000",
    "points": 5,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": [],
  },
  "Auftragskontrolle": {
    "color": "00ff00",
    "points": 1,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": [],
  },
  "Organisatorische": {
    "color": "00ff00",
    "points": 2,
    "comment": "k. A.",
    "yes": [],
    "no": [],
    "partial": []
  }
}

export const newRiskAnalysis = {
  "id": null,
  "comments": [],
  "vt_detail": {
    id: null,
    customer: '',
    name: ''
  },
  "vt": null,
  "reason": "",
  "description": "",
  "elementary_hazards": 0,
  "force_majeure": 0,
  "organizational_deficiencies": 0,
  "human_misactions": 0,
  "technical_failure": 0,
  "intentional_actions": 0,
  "failure_other_infrastructures": 0,
  "unintentional_attacks": 0,
  "targeted_it_attacks": 0,
  "computer_viruses_malware": 0,
  "eavesdropping_communication": 0,
  "theft_mobile_devices": 0,
  "data_transmission_third_countries": 0,
  "explanation_with_tom": 0,
  "bsi_basis": 0,
  "discrimination": 0,
  "identity_theft_fraud": 0,
  "financial_loss": 0,
  "reputation_damage": 0,
  "loss_confidentiality": 0,
  "violation_professional_secrets": 0,
  "unauthorized_reversal_pseudonymization": 0,
  "other_significant_economic_societal_disadvantages": 0,
  "loss_control_data": 0,
  "impairment_rights_freedoms": 0,
  "sensitive_data": 0,
  "personal_aspects": 0,
  "especially_vulnerable_persons": 0,
  "special_scope": 0,
  "dsgvo_basis": 0,
  "modified_by": null
}

export const RISKLEVEL = {
  'normal': 'Normal',
  'high': 'Hoch',
  'very high': 'Sehr Hoch',
}

export const dataTypeCategory = [
  {value: 'basis', label: 'Allgemeine Basisdaten/Stammdaten'},
  {value: 'special', label: 'Spezifische personenbezogene Daten'},
  {value: 'individual', label: 'Individuelle personenbezogene Daten'},
  {value: 'sensitive', label: 'Besondere Kategorien von personenbezogenen Daten'},
]

export const numberOfPerson = [
  {value: '<50', label: '<50'},
  {value: '50-99', label: '50-99'},
  {value: '100-200', label: '100-200'},
  {value: '>200', label: '>200'}
]

export const categoryChoices = {
  'Item 1': 'basis',
    'Item 2': 'special',
    'Item 3': 'individual',
    'Item 4': 'sensitive',
}

export const personNumberChoices = {
  'Item 1': '<50',
    'Item 2': '50-99',
    'Item 3': '100-200',
    'Item 4': '>200',
}

export const offlineModels = [
  'Gap Analyse',
  'Maßnahmenplan',
  'VT',
  'Risikobewertung',
  'VT(Selbst Datenverarbeiter)',
  'Gemeinsame Verantwortung',
  'Systeme',
  'Dienstleister',
  'Vorfälle',
  'Review/Audit',
  'AV Check',
  'TOM',
]

export const relatedModels = [
  ['Gap Analyse', 'Maßnahmenplan'],
  ['VT', 'Systeme', 'Dienstleister'],
]

export const  newSystemAssessment = {
  "id": null,
  "name": "",
  "survey": 9,
  "token": null,
  "password": null,
  "email": null,
  "customer": null,
  "result": null,
  "is_standard": true,
  "is_upgrade": false,
  "risk_analysis_result": null,
  "ai_results": [],
  "link_sent": false,
  "evaluation_path": null,
  "evaluation": null,
  "evaluated_by": null,
  "report_url": null,
  "status": "Offen",
  "remarks": "",
  "valid_date": null,
  "approved": false,
  "template": false,
  "gap_entry": true,
  "created_by": null,
  "modified_by": null,
  "created_on": null,
  "modified_on": null,
}

export const newAIResult = {
  "id": null,
  "name": "",
  "survey": null,
  "token": null,
  "password": null,
  "email": null,
  "system_assessment": [],
  "result": {},
  "status": "Offen",
  "ai_remarks": "",
  "template": false,
  "link_sent": false,
  "created_by": null,
  "modified_by": null,
  "created_on": null,
  "modified_on": null,
}

export const newDSFAResult = {
  "id": null,
  "name": "",
  "survey": null,
  "system_assessment": null,
  "result": {},
  "status": "open",
  "dsfa_remarks": "",
  "created_by": null,
  "modified_by": null,
  "created_on": null,
  "modified_on": null,
}

/*export const offlineURLs = {
  'Gap Analyse': {
    list: [
      `todos/v1/irrelevant_questions/${store.account.accountid}/?cb=${Date.now()}`,
      `todos/v1/questions/${store.account.accountid}/?cb=${Date.now()}`,
    ],
    single: 'todos/v1/get_gap/{{ id }}'
  },
  'Maßnahmenplan': {
    list: [
      `todos/v1/get_tasks/${store.account.accountid}/`,
    ],
    single: 'todos/v1/get_task/{{ id }}/',
  },
  'VT': {
    list: [
      `todos/v1/vt/${store.account.accountid}/`
    ],
    single: ''
  },
  'Systeme': {
    single: 'todos/v1/get_system/{{ id }}/'
  },
  'Dienstleister': {
    single: 'todos/v1/get_supplier/{{ id }}/'
  }
}*/

export const brancheDefaults = {
  // Dienstleistungen
  beratung: {
    targetAudience: 'B2B (Geschäftskunden, Unternehmen)',
    affectedPersons: 'Mitarbeiter, Bewerber, Unternehmenskunden, Ansprechpartner, Dienstleister',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'M365, CRM (HubSpot / Salesforce), DATEV, Personio, Teams, Zoom'
  },
  marketing: {
    targetAudience: 'B2B & B2C (Auftraggeber, Endkunden, Leads)',
    affectedPersons: 'Mitarbeiter, Bewerber, Kunden, Leads / Newsletter-Abonnenten, Dienstleister',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Google Analytics, Meta Business Suite, HubSpot / Mailchimp, M365, Adobe Creative Cloud, WordPress'
  },
  recruiting: {
    targetAudience: 'B2B (Unternehmen, Arbeitgeber)',
    affectedPersons: 'Bewerber / Kandidaten, Mitarbeiter, Kunden-Ansprechpartner, Dienstleister',
    specialData: 'Ggf. Gesundheitsdaten (Schwerbehinderung bei Bewerbungen), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Personio, LinkedIn Recruiter, Xing, StepStone, M365, DATEV'
  },
  reinigung: {
    targetAudience: 'B2B & B2C (Gewerbe- und Privatkunden)',
    affectedPersons: 'Mitarbeiter, Reinigungskräfte, Bewerber, Kunden, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Branchensoftware Gebäudereinigung, M365, DATEV, Zeiterfassungs-App'
  },
  sicherheit: {
    targetAudience: 'B2B & B2C (Unternehmen, Veranstalter, Privatkunden)',
    affectedPersons: 'Mitarbeiter, Sicherheitskräfte, Bewerber, Kunden, Besucher (Videoüberwachung)',
    specialData: 'Führungszeugnisse, ggf. Videoüberwachung / biometrische Daten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Wächterkontrollsysteme, Videoüberwachungssoftware, M365, DATEV'
  },
  uebersetzung: {
    targetAudience: 'B2B & B2C (Unternehmen, Behörden, Privatkunden)',
    affectedPersons: 'Mitarbeiter, freie Übersetzer / Freelancer, Bewerber, Kunden',
    specialData: 'Ggf. vertrauliche/besondere Daten in Übersetzungstexten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'CAT-Tools (SDL Trados, memoQ), DeepL Pro, M365, DATEV'
  },
  sonstige_dienstleistungen: {
    targetAudience: 'B2B & B2C (Geschäfts- und Privatkunden)',
    affectedPersons: 'Mitarbeiter, Bewerber, Kunden, Ansprechpartner, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'M365, DATEV, CRM-Software, Buchhaltungssoftware'
  },

  // Handel und Verkauf
  einzelhandel: {
    targetAudience: 'B2C (Endverbraucher, Laufkundschaft)',
    affectedPersons: 'Kunden, Mitarbeiter, Bewerber, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Kassensystem (POS), Warenwirtschaft, EC-Terminals, DATEV, M365'
  },
  grosshandel: {
    targetAudience: 'B2B (Wiederverkäufer, Handwerker, Geschäftskunden)',
    affectedPersons: 'Mitarbeiter, Bewerber, Unternehmenskunden, Ansprechpartner, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP-System (SAP, MS Dynamics), DATEV, M365, CRM'
  },
  e_commerce: {
    targetAudience: 'B2C & B2B (Online-Käufer, Besteller)',
    affectedPersons: 'Online-Kunden, Newsletter-Empfänger, Mitarbeiter, Bewerber, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Shopify / Shopware / WooCommerce, Klaviyo / Mailchimp, Stripe / PayPal, Warenwirtschaft, Google Analytics'
  },
  import_export: {
    targetAudience: 'B2B (Internationale Geschäftspartner, Händler)',
    affectedPersons: 'Mitarbeiter, Bewerber, Geschäftskunden, Spediteure, Zollagenten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP-System, Zollsoftware (ATLAS), M365, DATEV'
  },
  automobilhandel: {
    targetAudience: 'B2C & B2B (Fahrzeugkäufer, Werkstattkunden, Leasingnehmer)',
    affectedPersons: 'Kunden, Interessenten / Probefahrer, Mitarbeiter, Bewerber, Lieferanten',
    specialData: 'Führerscheindaten (Kopie), Bonitätsauskünfte, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Dealer Management System (DMS), Mobile.de / AutoScout24 Schnittstellen, DATEV, M365'
  },
  sonstiger_handel: {
    targetAudience: 'B2B & B2C (Geschäfts- und Privatkunden)',
    affectedPersons: 'Kunden, Mitarbeiter, Bewerber, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Warenwirtschaft / ERP, Kassensystem, DATEV, M365'
  },

  // Technologie und Medien
  softwareentwicklung: {
    targetAudience: 'B2B (Geschäftskunden, Plattformnutzer)',
    affectedPersons: 'Mitarbeiter, Bewerber, Unternehmenskunden, Software-Nutzer, Freelancer',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'GitHub / GitLab, Jira, Slack, AWS / Hetzner Cloud, M365 / Google Workspace, Personio, DATEV'
  },
  it_dienstleistungen: {
    targetAudience: 'B2B (KMU, Konzerne, Organisationen)',
    affectedPersons: 'Mitarbeiter, Bewerber, Kunden, Endbenutzer bei Kunden, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Ticketingsystem (Jira / Zendesk), RMM / Fernwartung (TeamViewer / AnyDesk), M365, DATEV'
  },
  saas: {
    targetAudience: 'B2B & B2C (Abonnenten, Plattform-Nutzer)',
    affectedPersons: 'Nutzer / Kontoinhaber, Mitarbeiter, Bewerber, Website-Besucher, Zahlungsdienstleister',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'AWS / Google Cloud, Stripe, Intercom / Zendesk, HubSpot, Datadog, GitHub, Google Analytics'
  },
  telekommunikation: {
    targetAudience: 'B2C & B2B (Mobilfunk- und Internetkunden, Firmenkunden)',
    affectedPersons: 'Kunden, Teilnehmer, Mitarbeiter, Bewerber, Vertriebspartner',
    specialData: 'Telekommunikations-Verkehrsdaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Billing- und Abrechnungssysteme, CRM, Netzwerk-Monitoring, M365, DATEV'
  },
  medien: {
    targetAudience: 'B2C & B2B (Leser, Abonnenten, Anzeigenkunden)',
    affectedPersons: 'Abonnenten, Autoren / Journalisten, Mitarbeiter, Bewerber, Werbekunden',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Redaktionssystem (CMS), Abonnentenverwaltung, M365, Adobe Creative Cloud, DATEV'
  },
  film_und_video: {
    targetAudience: 'B2B & B2C (Auftraggeber, Rundfunkanstalten, Zuschauer)',
    affectedPersons: 'Mitarbeiter, Darsteller / Models, Crew, Kunden, Bewerber',
    specialData: 'Bild- und Tonaufnahmen (Recht am eigenen Bild), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Adobe Premiere / DaVinci Resolve, Frame.io, M365, Cloud-Speicher, DATEV'
  },
  sonstige_technologie: {
    targetAudience: 'B2B & B2C',
    affectedPersons: 'Mitarbeiter, Bewerber, Kunden, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'M365, Jira, Cloud-Infrastruktur, DATEV'
  },

  // Finanzen und Versicherungen
  bankwesen: {
    targetAudience: 'B2C & B2B (Kontoinhaber, Kreditnehmer, Anleger, Firmenkunden)',
    affectedPersons: 'Bankkunden, Kontoinhaber, Bürgen, Mitarbeiter, Bewerber',
    specialData: 'Finanzdaten, Bonitätsdaten (SCHUFA), GwG-Identifikationsdaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Kernbankensystem, Video-Ident-Systeme, SCHUFA-Schnittstelle, M365, Compliance-Tools'
  },
  finanzdienstleistungen: {
    targetAudience: 'B2B & B2C (Investoren, Finanzierungskunden, Sparer)',
    affectedPersons: 'Kunden, Anleger, Mitarbeiter, Bewerber, Vermittler',
    specialData: 'Finanz- und Bonitätsdaten, GwG-Ausweisdaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Finanzsoftware, CRM, GwG-Prüftools, DATEV, M365'
  },
  versicherung: {
    targetAudience: 'B2C & B2B (Versicherungsnehmer, versicherte Personen, Firmenkunden)',
    affectedPersons: 'Versicherungsnehmer, Anspruchsteller, Geschädigte, Mitarbeiter, Bewerber',
    specialData: 'Gesundheitsdaten (bei Personenversicherungen), Schadensberichte, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Bestandsführungssystem, Schadensmanagementsystem, CRM, M365, DATEV'
  },
  steuerberatung: {
    targetAudience: 'B2B & B2C (Mandanten: Unternehmen, Freiberufler, Privatpersonen)',
    affectedPersons: 'Mandanten, Arbeitnehmer der Mandanten (Lohnbuchhaltung), Mitarbeiter, Bewerber',
    specialData: 'Finanzdaten, Religionszugehörigkeit (Kirchensteuer), Krankmeldungen (Lohn/HR)',
    toolsSoftware: 'DATEV (Unternehmen online, Kanzleimanagement), M365, DMS'
  },
  wirtschaftspruefung: {
    targetAudience: 'B2B (Prüfungsmandanten, Konzerne, Mittelstand)',
    affectedPersons: 'Mandanten-Mitarbeiter, Organe / Geschäftsführer, Kanzleimitarbeiter, Bewerber',
    specialData: 'Finanzdaten, vertrauliche Mandantendaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Audit-Software (CaseWare, DATEV), DMS, M365'
  },
  buchhaltung: {
    targetAudience: 'B2B (Auftraggeber, Unternehmen, Selbstständige)',
    affectedPersons: 'Mandanten, Mitarbeiter der Mandanten (Lohnbuchhaltung), eigene Mitarbeiter, Bewerber',
    specialData: 'Finanz- und Lohndaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'DATEV, Lexware, sevDesk, Addison, M365'
  },
  immobilien: {
    targetAudience: 'B2C & B2B (Mieter, Vermieter, Käufer, Verkäufer, Eigentümer)',
    affectedPersons: 'Mietinteressenten, Mieter, Eigentümer, Mitarbeiter, Bewerber, Handwerker',
    specialData: 'Bonitätsauskünfte (SCHUFA, Gehaltsnachweise, Selbstauskunft), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ImmobilienScout24, Immoware24 / onOffice, DATEV, M365'
  },

  // Gesundheit und Soziales
  arztpraxis: {
    targetAudience: 'B2C (Patienten, gesetzlich & privat Versicherte)',
    affectedPersons: 'Patienten, Angehörige, Mitarbeiter, Bewerber, überweisende Ärzte, Labore',
    specialData: 'Gesundheitsdaten (Diagnosen, Befunde, Therapien, Medikation nach Art. 9 DSGVO)',
    toolsSoftware: 'Praxisverwaltungssoftware (medatixx / CGM / Turbomed), Telematikinfrastruktur (KIM), DATEV'
  },
  pflege: {
    targetAudience: 'B2C (Pflegebedürftige, Bewohner, Angehörige)',
    affectedPersons: 'Pflegebedürftige, Angehörige, Pflegekräfte / Mitarbeiter, Bewerber, Ärzte',
    specialData: 'Gesundheits- und Pflegedaten (Pflegegrad, Diagnosen, Medikation nach Art. 9 DSGVO)',
    toolsSoftware: 'Pflegesoftware (mediFox, Dan Produkte), Dienstplanungs-App, DATEV, M365'
  },
  therapie: {
    targetAudience: 'B2C (Patienten, Klienten)',
    affectedPersons: 'Patienten / Klienten, Angehörige, Mitarbeiter, Bewerber, Ärzte',
    specialData: 'Gesundheitsdaten (Therapieberichte, Diagnosen nach Art. 9 DSGVO)',
    toolsSoftware: 'Praxissoftware (Theorg, buchner), Abrechnungsdienstleister, M365, DATEV'
  },
  apotheke: {
    targetAudience: 'B2C & B2B (Kunden, Heime, Ärzte)',
    affectedPersons: 'Kunden, Patienten (E-Rezept), Mitarbeiter, Bewerber, Lieferanten',
    specialData: 'Gesundheitsdaten (Rezepte, Medikationspläne, Krankenkassendaten nach Art. 9 DSGVO)',
    toolsSoftware: 'Apotheken-Warenwirtschaft (ADG, NOVENTI, Pharmatechnik), Telematikinfrastruktur, DATEV'
  },
  fitness: {
    targetAudience: 'B2C (Mitglieder, Studiobesucher, Sportler)',
    affectedPersons: 'Mitglieder, Interessenten / Probetrainierende, Trainer, Mitarbeiter, Bewerber',
    specialData: 'Ggf. Gesundheitsdaten (Anamnesebögen, Fitnesszustand), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Mitgliederverwaltungssoftware (Magicline, DSB), Zutrittskontrollsystem, DATEV, M365'
  },
  soziale_einrichtung: {
    targetAudience: 'B2C (Klienten, Hilfebedürftige, Jugendliche, Familien)',
    affectedPersons: 'Betreute Personen, Angehörige, Sozialarbeiter, Mitarbeiter, Bewerber, Behörden',
    specialData: 'Gesundheitsdaten, Sozialdaten, familiäre Daten nach Art. 9 DSGVO',
    toolsSoftware: 'Fachsoftware Soziales, DMS, M365, DATEV'
  },
  sonstige_gesundheit: {
    targetAudience: 'B2C (Patienten, Klienten, Kunden)',
    affectedPersons: 'Patienten, Kunden, Mitarbeiter, Bewerber',
    specialData: 'Gesundheitsdaten nach Art. 9 DSGVO',
    toolsSoftware: 'Branchensoftware Medizin/Gesundheit, DATEV, M365'
  },

  // Industrie und Produktion
  maschinenbau: {
    targetAudience: 'B2B (Industriekunden, Anlagenbetreiber, OEM)',
    affectedPersons: 'Mitarbeiter, Bewerber, Unternehmenskunden, Zulieferer, Servicetechniker',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP (SAP / Microsoft Dynamics), CAD / PLM-Software, M365, DATEV'
  },
  automobilindustrie: {
    targetAudience: 'B2B (Automobilhersteller, Tier-1/Tier-2-Zulieferer)',
    affectedPersons: 'Mitarbeiter, Bewerber, Unternehmenskunden, Lieferanten, externe Werksbesucher',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'SAP, EDI-Systeme, PLM-Tools, M365, TISAX-relevante Systeme'
  },
  elektrotechnik: {
    targetAudience: 'B2B & B2C (Industriekunden, Großhändler, Endkunden)',
    affectedPersons: 'Mitarbeiter, Bewerber, Unternehmenskunden, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP-System, CAD, M365, DATEV'
  },
  chemie: {
    targetAudience: 'B2B (Industriekunden, Verarbeiter, Händler)',
    affectedPersons: 'Mitarbeiter, Bewerber, Geschäftskunden, Spediteure / Gefahrgutfahrer',
    specialData: 'Arbeitsmedizinische Vorsorgeuntersuchungen, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP (SAP), Gefahrstoffmanagement-Software, M365, DATEV'
  },
  pharma: {
    targetAudience: 'B2B (Großhändler, Apotheken, Kliniken, Ärzte)',
    affectedPersons: 'Mitarbeiter, Bewerber, Probanden (klinische Studien), Fachkreise / Ärzte',
    specialData: 'Ggf. Studiendaten / Gesundheitsdaten (Pharmakovigilanz), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Validierte ERP-Systeme (GMP), Vigilanz-Datenbanken, CRM (Veeva), M365'
  },
  lebensmittelproduktion: {
    targetAudience: 'B2B & B2C (Handelsketten, Gastronomie, Endverbraucher)',
    affectedPersons: 'Mitarbeiter (Hygieneschulungen nach IfSG), Bewerber, Lieferanten, Kunden',
    specialData: 'Belehrung / Gesundheitszeugnis nach IfSG, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP / Chargenrückverfolgung, QS-Software, M365, DATEV'
  },
  textil: {
    targetAudience: 'B2B & B2C (Modehandel, Kaufhäuser, Endkunden)',
    affectedPersons: 'Mitarbeiter, Bewerber, Kunden, Lieferanten / Konfektionäre',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP / PDM, E-Commerce Plattform, DATEV, M365'
  },
  sonstige_produktion: {
    targetAudience: 'B2B (Gewerbe- und Industriekunden)',
    affectedPersons: 'Mitarbeiter, Bewerber, Kunden, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP-System, Betriebsdatenerfassung (BDE), M365, DATEV'
  },

  // Bauwesen und Handwerk
  bauunternehmen: {
    targetAudience: 'B2B & B2C (Bauherren, öffentliche Auftraggeber, Investoren)',
    affectedPersons: 'Mitarbeiter, Bauarbeiter / Subunternehmer, Bewerber, Bauherren, Architekten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Bausoftware (Nevaris, BRZ, RIB iTWO), mobile Zeiterfassung, DATEV, M365'
  },
  architektur: {
    targetAudience: 'B2B & B2C (Bauherren, Bauträger, Kommunen)',
    affectedPersons: 'Bauherren, Mitarbeiter, Bewerber, Fachplaner, Behörden-Ansprechpartner',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'CAD / BIM (ArchiCAD, Revit, AutoCAD), AVA-Software (ORCA AVA), M365'
  },
  ingenieurwesen: {
    targetAudience: 'B2B (Industriekunden, Bauträger, öffentliche Hand)',
    affectedPersons: 'Mitarbeiter, Bewerber, Auftraggeber, Projektpartner',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'CAD / Berechnungssoftware, Projektmanagement-Tools, M365, DATEV'
  },
  elektrohandwerk: {
    targetAudience: 'B2B & B2C (Privatkunden, Gewerbebetriebe, Hausverwaltungen)',
    affectedPersons: 'Kunden, Mitarbeiter, Bewerber, Lieferanten, Subunternehmer',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Handwerkersoftware (KWP, Streit V.1), mobile Zeiterfassung, DATEV, M365'
  },
  sanitaer_heizung_klima: {
    targetAudience: 'B2B & B2C (Privatkunden, Hausverwaltungen, Gewerbe)',
    affectedPersons: 'Kunden, Mitarbeiter, Monteure, Bewerber, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Handwerkersoftware (pds, WinWorker, KWP), mobile Auftragsabwicklung, DATEV, M365'
  },
  maler_und_lackierer: {
    targetAudience: 'B2C & B2B (Privatkunden, Wohnungsbaugesellschaften)',
    affectedPersons: 'Kunden, Mitarbeiter, Malergesellen, Bewerber, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'WinWorker, Maler-Spezialsoftware, mobile Zeiterfassung, DATEV'
  },
  schreinerei: {
    targetAudience: 'B2C & B2B (Privatkunden, Inneneinrichter, Architekten)',
    affectedPersons: 'Kunden, Mitarbeiter, Schreiner, Bewerber, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'CAD / CAM (Palette CAD, imos), Handwerkersoftware, DATEV, M365'
  },
  sonstiges_handwerk: {
    targetAudience: 'B2C & B2B (Privatkunden, Gewerbekunden)',
    affectedPersons: 'Kunden, Mitarbeiter, Bewerber, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Handwerkersoftware, mobile Zeiterfassung, DATEV, M365'
  },

  // Transport und Logistik
  spedition: {
    targetAudience: 'B2B (Verlader, Industrie, Händler)',
    affectedPersons: 'Mitarbeiter, Fahrer / LKW-Fahrer, Bewerber, Unternehmenskunden, Subunternehmer',
    specialData: 'Führerschein- und Fahrerkarte-Daten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Speditionssoftware / TMS, Telematik / GPS-Tracking, DATEV, M365'
  },
  logistik: {
    targetAudience: 'B2B (Handel, E-Commerce, Industrie)',
    affectedPersons: 'Mitarbeiter, Lagerpersonal, Bewerber, Auftraggeber, Spediteure',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Warehouse Management System (WMS), Barcode-Scanner, ERP, DATEV, M365'
  },
  kurierdienst: {
    targetAudience: 'B2B & B2C (Versender und Empfänger)',
    affectedPersons: 'Empfänger (Zustelldaten), Versender, Kuriere / Fahrer, Mitarbeiter, Bewerber',
    specialData: 'Unterschrift bei Übergabe, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Tourenplanung, Zustell-App / Handscanner, Tracking-Plattform, DATEV'
  },
  personenverkehr: {
    targetAudience: 'B2C & B2B (Fahrgäste, Pendler, Reisegruppen)',
    affectedPersons: 'Fahrgäste, Fahrer, Mitarbeiter, Bewerber, Ticketkäufer',
    specialData: 'Fahrgastdaten, Videoüberwachung im Fahrzeug, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Ticketingsystem, Fahrplanungssoftware, Telematik, DATEV, M365'
  },
  lagerung: {
    targetAudience: 'B2B (Handel, Hersteller)',
    affectedPersons: 'Mitarbeiter, Lagerpersonal, Bewerber, Kunden-Ansprechpartner',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Lagerverwaltungssystem (LVS), M365, DATEV'
  },
  sonstiger_transport: {
    targetAudience: 'B2B & B2C',
    affectedPersons: 'Mitarbeiter, Fahrer, Kunden, Lieferanten',
    specialData: 'Ggf. Telematik-/Ortungsdaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Flottenmanagement, Dispositionssoftware, DATEV, M365'
  },

  // Gastronomie, Tourismus und Freizeit
  gastronomie: {
    targetAudience: 'B2C (Gäste, Besucher, Eventkunden)',
    affectedPersons: 'Gäste (Tischreservierungen), Mitarbeiter (Küche, Service), Bewerber, Lieferanten',
    specialData: 'Ggf. Allergien / Unverträglichkeiten (Gesundheitsdaten), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Kassensystem (POS z. B. Gastronovi, Orderbird), Reservierungstool (OpenTable / Resmio), DATEV'
  },
  hotel: {
    targetAudience: 'B2C & B2B (Hotelgäste, Urlauber, Geschäftsreisende, Tagungsteilnehmer)',
    affectedPersons: 'Hotelgäste (Meldescheine), Mitarbeiter, Bewerber, Lieferanten',
    specialData: 'Meldescheindaten (Passdaten), Kreditkartendaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Property Management System (PMS z. B. protel, Apaleo), Channel Manager, Kassensystem, DATEV'
  },
  reiseveranstalter: {
    targetAudience: 'B2C & B2B (Reisende, Urlauber, Gruppen)',
    affectedPersons: 'Reisende, Mitarbeiter, Bewerber, Partnerhotels, Fluggesellschaften',
    specialData: 'Reisepassdaten, Visadaten, ggf. gesundheitliche Mobilitätsangaben, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Buchungssystem (Amadeus, Sabre), CRM, M365, DATEV'
  },
  veranstaltungen: {
    targetAudience: 'B2B & B2C (Teilnehmer, Veranstalter, Besucher)',
    affectedPersons: 'Teilnehmer, Referenten, Mitarbeiter, Bewerber, Dienstleister',
    specialData: 'Ggf. Foto-/Videoaufnahmen, Verpflegungswünsche (Allergien), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Ticketing-Plattform (Eventbrite / Xing Events), Event-App, M365, DATEV'
  },
  sport_und_freizeit: {
    targetAudience: 'B2C (Freizeitsportler, Mitglieder, Besucher)',
    affectedPersons: 'Besucher, Mitglieder, Mitarbeiter, Trainer, Bewerber',
    specialData: 'Ggf. Notfallkontaktdaten / Gesundheitsangaben, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Buchungs- und Kassensystem, Mitgliederverwaltung, DATEV, M365'
  },
  kultur: {
    targetAudience: 'B2C (Kulturliebhaber, Museumsbesucher, Theatergäste)',
    affectedPersons: 'Besucher, Abonnenten, Künstler, Mitarbeiter, Bewerber',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Ticketingsystem, Newsletter-Tool, M365, DATEV'
  },

  // Bildung und Forschung
  schule: {
    targetAudience: 'B2C (Schüler, Eltern, Erziehungsberechtigte)',
    affectedPersons: 'Schüler, Eltern, Lehrer / pädagogisches Personal, Bewerber, Schulverwaltung',
    specialData: 'Noten / Zeugnisse, Förderbedarf, Atteste / Gesundheitsdaten, Krankmeldungen',
    toolsSoftware: 'Schulverwaltungssoftware (WebUntis, FuxSchool), Lernplattform (Moodle, Teams), Schul-Cloud'
  },
  weiterbildung: {
    targetAudience: 'B2B & B2C (Teilnehmer, Fachkräfte, Arbeitgeber)',
    affectedPersons: 'Teilnehmer, Dozenten, Mitarbeiter, Bewerber, Firmenkunden',
    specialData: 'Leistungsnachweise, Zertifikate, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'LMS (Moodle), Videokonferenz (Zoom / Teams), CRM, DATEV'
  },
  kindergarten: {
    targetAudience: 'B2C (Kinder, Eltern, Erziehungsberechtigte)',
    affectedPersons: 'Kinder, Eltern, Erzieher / pädagogisches Personal, Bewerber',
    specialData: 'Gesundheitsdaten (Impfstatus / Masern, Allergien, Notfallkontakte), Entwicklungsberichte',
    toolsSoftware: 'Kita-Verwaltungssoftware (KiKom, Stay-Informed), M365, DATEV'
  },
  hochschule: {
    targetAudience: 'B2C & B2B (Studierende, Forschende, Partneruniversitäten)',
    affectedPersons: 'Studierende, Professoren / Lehrbeauftragte, wissenschaftliche Mitarbeiter, Bewerber',
    specialData: 'Prüfungsdaten, Immatrikulationsdaten, Krankmeldungen',
    toolsSoftware: 'Campus-Management-System (HIS / CampusOnline), Moodle, M365, Cloud-Speicher'
  },
  forschung: {
    targetAudience: 'B2B (Förderer, Kooperationspartner, wissenschaftliche Community)',
    affectedPersons: 'Wissenschaftler, Projektmitarbeiter, Probanden (je nach Studie), Bewerber',
    specialData: 'Ggf. Probandendaten / Studiendaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Forschungsdaten-Repositories, Kollaborationstools (Git, Overleaf), M365, SAP'
  },

  // Landwirtschaft und Umwelt
  landwirtschaft: {
    targetAudience: 'B2B & B2C (Abnehmer, Genossenschaften, Hofladen-Kunden)',
    affectedPersons: 'Mitarbeiter, Saisonarbeitskräfte, Bewerber, Abnehmer, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Agrar-Software / Ackerschlagkartei, Warenwirtschaft, DATEV, M365'
  },
  forstwirtschaft: {
    targetAudience: 'B2B (Holzverarbeiter, Sägewerke, Waldbesitzer)',
    affectedPersons: 'Mitarbeiter, Forstarbeiter, Bewerber, Kunden, Holzkäufer',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Forstverwaltungssoftware, GIS / Geodaten, DATEV, M365'
  },
  gartenbau: {
    targetAudience: 'B2C & B2B (Privatkunden, Kommunen, Unternehmen)',
    affectedPersons: 'Kunden, Mitarbeiter, Gärtner, Bewerber, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'GaLaBau-Branchensoftware (DATAflor), mobile Zeiterfassung, DATEV'
  },
  energie: {
    targetAudience: 'B2C & B2B (Strom-/Gaskunden, Einspeiser, Netzbetreiber)',
    affectedPersons: 'Kunden (Zählerdaten / Verbrauch), Mitarbeiter, Bewerber, Netzpartner',
    specialData: 'Zählerstände / Verbrauchsdaten (Smart Meter), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'ERP (SAP for Utilities), Abrechnungssystem, CRM, M365, DATEV'
  },
  abfallwirtschaft: {
    targetAudience: 'B2B & B2C (Haushalte, Kommunen, Gewerbebetriebe)',
    affectedPersons: 'Kunden / Bürger, Mitarbeiter, Fahrer, Bewerber, Entsorgungspartner',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Entsorgungs- und Telematiksoftware, Wiegesysteme, ERP, DATEV, M365'
  },
  umweltdienstleistungen: {
    targetAudience: 'B2B (Industrie, Kommunen, Projektentwickler)',
    affectedPersons: 'Mitarbeiter, Gutachter, Bewerber, Kunden, Behörden',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'GIS-Software, Mess- und Analysesoftware, M365, DATEV'
  },

  // Öffentlicher Bereich und Organisationen
  oeffentliche_verwaltung: {
    targetAudience: 'B2C & B2B (Bürger, Unternehmen, Antragsteller)',
    affectedPersons: 'Bürger, Antragsteller, Mitarbeiter / Beamte, Bewerber',
    specialData: 'Sozialdaten, Steuerdaten, Registerdaten, Krankmeldungen',
    toolsSoftware: 'Fachverfahren der Verwaltung, E-Akte (DMS), Service-Portal (OZG), M365 / OpenDesk'
  },
  verein: {
    targetAudience: 'B2C (Vereinsmitglieder, Förderer, Interessierte)',
    affectedPersons: 'Mitglieder, Vorstandsmitglieder, Übungsleiter, Spender, Mitarbeiter',
    specialData: 'Ggf. Gesundheitsdaten (Sportunfälle), Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Vereinsverwaltungssoftware (ClubDesk, Kurabu, easyVerein), Banken-Schnittstelle (SEPA), M365'
  },
  verband: {
    targetAudience: 'B2B (Mitgliedsunternehmen, Fachvertreter)',
    affectedPersons: 'Verbandsmitglieder, Ansprechpartner der Unternehmen, Mitarbeiter, Bewerber',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Mitglieder-CRM, Newsletter-Software, M365, DATEV'
  },
  stiftung: {
    targetAudience: 'B2C & B2B (Stipendiaten, Geförderte, Spender, Partner)',
    affectedPersons: 'Geförderte Personen, Antragsteller, Spender, Stiftungsrat, Mitarbeiter',
    specialData: 'Ggf. Förderungs- und Finanzdaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Stiftungsverwaltungssoftware, CRM, M365, DATEV'
  },
  religionsgemeinschaft: {
    targetAudience: 'B2C (Gemeindemitglieder, Gläubige, Hilfesuchende)',
    affectedPersons: 'Gemeindemitglieder, Geistliche, ehrenamtliche Helfer, Mitarbeiter',
    specialData: 'Religiöse Überzeugungen (Art. 9 DSGVO), Tauf-/Eheregister, Seelsorgedaten',
    toolsSoftware: 'Gemeindeverwaltungssoftware, Meldewesen-Schnittstelle, M365, Buchhaltung'
  },
  nicht_regierungsorganisation: {
    targetAudience: 'B2C & B2B (Unterstützer, Spender, Begünstigte)',
    affectedPersons: 'Spender, Aktivisten / Ehrenamtliche, Begünstigte, Mitarbeiter, Bewerber',
    specialData: 'Ggf. weltanschauliche Überzeugungen, Spenderkontodaten, Krankmeldungen im HR-Bereich',
    toolsSoftware: 'Fundraising- und CRM-Software, Newsletter-Tool, M365, DATEV'
  },

  // Sonstige
  sonstige: {
    targetAudience: 'B2B & B2C',
    affectedPersons: 'Mitarbeiter, Bewerber, Kunden, Lieferanten',
    specialData: 'Nur Krankmeldungen im HR-Bereich',
    toolsSoftware: 'M365, DATEV, CRM-Software'
  }
};
